import { NsExpander } from 'components/common/ns-expander/NsExpander';
import { useHasSmartMeter } from 'components/direct-sales/quote/hooks/useHasSmartMeter';
import { usePaymentMethod } from 'hooks/usePaymentMethod';
import { NsAnchor } from 'components/common/ns-anchor/NsAnchor';
import { actionUrl } from 'config/static-content';

export const testId = 'moreInformationTestId';
export const testIdSmartMeterText = 'testIdSmartMeterText';

export const MoreInformation = () => {
  const { hasAllSmartMeter } = useHasSmartMeter();
  const { isAnyDirectDebit } = usePaymentMethod();

  return (
    <NsExpander heading="More information" id="moreInformation" testId={testId}>
      <p>
        Estimated annual costs and the tariff rates quoted include 5% VAT. The
        tariff rates you’ll see on your bill/statement will be slightly lower,
        as they won&apos;t include VAT (VAT is added on at the end of your
        bill).
      </p>
      <p>
        The mix of fuels we use to generate the electricity supplied to
        customers - along with their environmental impact - is known as the Fuel
        Mix Disclosure and we publish it every year.{' '}
        <NsAnchor
          href="https://www.britishgas.co.uk/about-us/tariffs-with-environmental-benefits.html"
          target="_blank"
        >
          View Fuel Mix online
        </NsAnchor>
      </p>
      <p>
        Read British Gas{' '}
        <NsAnchor href={actionUrl.bgTermsAndConditions} target="_blank">
          Terms & Conditions
        </NsAnchor>
      </p>
      <p>
        Information on our complaints policy can be found on our{' '}
        <NsAnchor
          href="https://www.britishgas.co.uk/complaints.html"
          target="_blank"
        >
          website
        </NsAnchor>
      </p>
      {isAnyDirectDebit && (
        <p>
          Your prices are lower with Direct Debit so if you move to a different
          payment method your prices will increase.
        </p>
      )}
      {hasAllSmartMeter ? (
        <p data-testid={testIdSmartMeterText}>
          We need you to provide regular meter readings to help keep your
          payments accurate. Given your meter type we would expect to be able to
          take automatic consumption readings. Every now and then things can go
          wrong but we will be sure to let you know.
        </p>
      ) : (
        <p data-testid={testIdSmartMeterText}>
          We need you to provide regular meter readings to help keep your
          payments accurate. You may already have a smart meter and send
          automatic readings, however some early smart meters are only
          compatible with the supplier that installed them.
        </p>
      )}
    </NsExpander>
  );
};

export default MoreInformation;
